import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { getCurrentUser } from '@/services/auth.service';
import { getFloorsByBuilding } from '@/services/floor.service';
import {
  addRoomReservation,
  deleteAdminOperation,
  deleteOperation,
  //   getMeetingsByUser,
  getRoomsOperations
} from '@/services/operation.service';
import { getUsers } from '@/services/user.service';
import { ArrowLeftLine, ArrowRightLine, Trash } from '@rsuite/icons';
import { format, isAfter, isBefore, isSameDay, isToday, subDays } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { LuCalendarDays, LuUsers } from 'react-icons/lu';
import {
  Button,
  Heading,
  IconButton,
  Panel,
  Stack,
  SelectPicker,
  Modal,
  Form,
  DatePicker,
  TagPicker,
  Input,
  InputGroup,
  Message,
  useToaster,
  Calendar,
  Avatar,
  Loader,
  Whisper,
  Tooltip,
  Card,
  Popover,
  Placeholder
} from 'rsuite';
import { fetchRooms } from '@/services/desk.service';
import { VscTrash } from 'react-icons/vsc';
import { MdEvent, MdGroup } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdInformationCircleOutline,
  IoMdTime
} from 'react-icons/io';
import { FaUserClock } from 'react-icons/fa';
import ConfirmModal from '@/components/ConfirmModal';
import { GrWorkshop } from 'react-icons/gr';

// const rooms = [
//   { _id: 1, name: 'Room 1', floor: 'Floor 2', capacity: 10 },
//   { _id: 2, name: 'Room 2', floor: 'Floor 2', capacity: 10 },
//   { _id: 3, name: 'Room 3', floor: 'Floor 2', capacity: 6 },
//   { _id: 4, name: 'Room 4', floor: 'Floor 2', capacity: 4 }
// ];

const generateHalfHourSlots = (start = 8, end = 18) => {
  const slots: any = [];
  for (let h = start; h < end; h++) {
    slots.push(`${String(h).padStart(2, '0')}:00`);
    slots.push(`${String(h).padStart(2, '0')}:30`);
  }
  return slots;
};

const hours = generateHalfHourSlots();

// const hours = [
//   '08:00',
//   '08:30',
//   '09:00',
//   '09:30',
//   '10:00',
//   '10:30',
//   '11:00',
//   '11:30',
//   '12:00',
//   '12:30',
//   '13:00',
//   '13:30',
//   '14:00',
//   '14:30',
//   '15:00',
//   '15:30',
//   '16:00',
//   '16:30',
//   '17:00',
//   '17:30',
//   '18:00',
//   '18:30'
//   // '19:00'
// ];
const MeetingSchedule = () => {
  const dispatch = useAppDispatch();

  const userConnected = getCurrentUser();
  const toaster = useToaster();

  const buildings = useAppSelector((state: any) => state.building?.data);
  const loadingBuildings = useAppSelector((state: any) => state.building?.loading);
  const loading = useAppSelector((state: any) => state.floor?.loading);

  const floors = useAppSelector((state: any) => state.floor?.data)
    .filter(item => item.type == 'office')
    .map(item => ({ ...item, value: item._id, label: item.name }));

  const rooms = useAppSelector((state: any) => state.desk?.rooms);
  const operations = useAppSelector((state: any) => state.operation.data);

  const users = useAppSelector((state: any) => state.users.data);
  const bookings = useAppSelector((state: any) => state.operation.userData);
  const loadingBookings = useAppSelector((state: any) => state.operation.userDataLoading);

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState(generateWeek(new Date()));
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedFloor, setSelectedFloor] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [linePosition, setLinePosition] = useState(0);

  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isSelecting, setIsSelecting] = useState(false);
  const gridRef = useRef(null);
  const schedulerRef = useRef(null);
  const [expanded, setExpanded] = useState(true);

  const [formValue, setFormValue] = useState<any>({
    date: null,
    startTime: '',
    endTime: '',
    teams: [],
    desk: ''
  });

  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    title: '',
    subtitle: '',
    loading: false
  });

  useEffect(() => {
    const handleClickOutside = event => {
      if (schedulerRef.current && !schedulerRef.current.contains(event.target)) {
        setSelectedSlots([]);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    selectedFloor && dispatch(fetchRooms(selectedFloor?._id));
  }, [selectedFloor]);

  useEffect(() => {
    if (buildings?.length > 0) {
      setSelectedBuilding(buildings[0]?._id);
    }
  }, [buildings]);

  useEffect(() => {
    selectedBuilding && dispatch(getFloorsByBuilding(selectedBuilding));
  }, [selectedBuilding]);

  useEffect(() => {
    if (floors?.length > 0 && !selectedFloor) {
      setSelectedFloor(floors[0]);
    }
  }, [floors]);

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    rooms &&
      rooms.length > 0 &&
      dispatch(
        getRoomsOperations(
          Array.from(rooms, ({ _id }) => _id),
          selectedDate
        )
      );
  }, [rooms, selectedDate]);

  const handleDateSelect = date => {
    const week = generateWeek(date);
    setSelectedWeek(week);
    // setSelectedDate(date);
    setShowCalendar(false);
  };

  const handleNextWeek = () => {
    const nextMonday = new Date(selectedWeek[selectedWeek.length - 1]);
    nextMonday.setDate(nextMonday.getDate() + 7);
    setSelectedWeek(generateWeek(nextMonday));
  };

  const handlePrevWeek = () => {
    const prevSunday = new Date(selectedWeek[0]);
    prevSunday.setDate(prevSunday.getDate() - 7);
    setSelectedWeek(generateWeek(prevSunday));
  };

  const handleMouseDown = (room, time, index) => {
    // if (reservations.some(slot => slot.room === room && slot.time === time)) return; // Empêcher la sélection des réservations

    if (isSelecting) {
      setIsSelecting(false);
      // const time = hours[index + 1];
      setSelectedSlots(prev => {
        const isDuplicate = prev.some(slot => slot.room === room && slot.time === time);
        if (isDuplicate) {
          return prev;
        }

        if (prev.length > 0 && prev[0].room !== room) {
          return prev;
        }

        return [...prev, { room, time }];
      });
      setFormValue(prevForm => ({ ...prevForm, endTime: hours[index + 1] }));

      // setFormValue(prevForm => ({ ...prevForm, date_fin: date.toISOString() }));
      setShowModal({ open: true, room: room, slots: selectedSlots });
    } else {
      setIsSelecting(true);
      setSelectedSlots([{ room, time }]);
      setFormValue(prevForm => ({
        ...prevForm,
        startTime: time,
        endTime: null,
        desk: room._id,
        user: userConnected.id
      }));
    }
  };

  const handleMouseEnter = (room, time) => {
    if (isSelecting) {
      setSelectedSlots(prev => {
        if (prev.length > 0 && prev[0].room !== room) {
          return prev;
        }

        const updatedSlots = prev.filter(slot => slot.room === room && slot.time <= time);

        if (!updatedSlots.some(slot => slot.room === room && slot.time === time)) {
          updatedSlots.push({ room, time });
        }

        return updatedSlots;
      });
    }
  };

  const handleConfirm = async () => {
    const startTime = format(selectedDate, 'yyyy-MM-dd') + 'T' + formValue.startTime + ':00Z';
    const endTime = format(selectedDate, 'yyyy-MM-dd') + 'T' + formValue.endTime + ':00Z';

    console.log('startTime', startTime);
    console.log('endTime', endTime);
    const reservation = {
      ...formValue,
      date_debut: startTime,
      date_fin: endTime
    };

    const result = await addRoomReservation(reservation);
    if (result.status === 200) {
      if (result.data && result.data.status == 201) {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            {t(result.data.message)}
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        toaster.push(
          <Message type="success" duration={5000} showIcon>
            {t(result.message)}
          </Message>,
          { placement: 'topCenter' }
        );
        dispatch(
          getRoomsOperations(
            Array.from(rooms, ({ _id }) => _id),
            selectedDate
          )
        );
      }
      setShowModal({ open: false });
    } else {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t(result.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const { t } = useTranslation();
  const handleDelete = async id => {
    try {
      setConfirmDialog(prevDialog => ({ ...prevDialog, loading: true }));
      const result = await dispatch(deleteAdminOperation(id));
      console.log('result', result);
      if (result.status === 200) {
        toaster.push(
          <Message type="success" duration={5000} showIcon>
            {t('Deleted Successfully.')}
          </Message>,
          { placement: 'topCenter' }
        );
        setSelectedSlots([]);
        dispatch(
          getRoomsOperations(
            Array.from(rooms, ({ _id }) => _id),
            selectedDate
          )
        );
      } else {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            {t(result.message)}
          </Message>,
          { placement: 'topCenter' }
        );
      }
      setConfirmDialog({ open: false, loading: false });
    } catch (error) {}
  };
  const MembersDisplay = ({ members }) => {
    const maxVisible = 1;
    const visibleMembers = members.slice(0, maxVisible);
    const hiddenMembers = members.slice(maxVisible);

    const renderHiddenTooltip = () => (
      <Popover>
        {hiddenMembers.map((member, index) => (
          <div key={index}>
            {member.firstname} {member.lastname}
          </div>
        ))}
      </Popover>
    );

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        {visibleMembers.map((member, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: '#3f5f89' }}>
              {member.firstname} {member.lastname}
            </span>
          </div>
        ))}

        {hiddenMembers.length > 0 && (
          <Whisper trigger="hover" placement="top" speaker={renderHiddenTooltip()}>
            <span style={{ fontSize: 12, color: '#888', cursor: 'pointer' }}>
              +{hiddenMembers.length} other{hiddenMembers.length > 1 ? 's' : ''}
            </span>
          </Whisper>
        )}
      </div>
    );
  };

  const canDelete = date_debut => {
    const now = new Date();
    return isAfter(new Date(date_debut), now);
  };

  return (
    <div className="resource-scheduler">
      <Panel
        style={{
          // padding: 10,
          marginBottom: 5
        }}
      >
        <Form
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            gap: 50
          }}
        >
          <Form.Group>
            <Form.ControlLabel>{t('Office')}</Form.ControlLabel>
            <SelectPicker
              data={buildings?.map(building => ({
                ...building,
                value: building?._id,
                label: building?.address
              }))}
              searchable={false}
              style={{ width: 200, backgroundColor: 'transparent' }}
              placeholder={t('Select Building')}
              value={selectedBuilding}
              onChange={setSelectedBuilding}
              loading={loadingBuildings}
            />
          </Form.Group>

          {loading ? (
            <Stack direction="row" spacing={10} justifyContent="flex-start">
              <Placeholder.Graph active style={{ height: 50 }} />
              <Placeholder.Graph active style={{ height: 50 }} />
              <Placeholder.Graph active style={{ height: 50 }} />
            </Stack>
          ) : (
            <Stack direction="row" spacing={10} justifyContent="flex-start">
              {floors?.map(floor => {
                return (
                  <Card
                    key={floor._id}
                    bordered
                    style={{
                      minWidth: 130,
                      height: 50,
                      textAlign: 'center',
                      background: 'none',
                      borderRadius: 10,
                      paddingRight: 15,
                      paddingLeft: 15,
                      backgroundColor:
                        selectedFloor?.floor_num === floor.floor_num
                          ? 'rgb(216, 227, 238)'
                          : 'transparent',
                      marginTop: 10,
                      cursor: 'pointer'
                      // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                    }}
                    onClick={() => {
                      setSelectedFloor(floor);
                    }}
                  >
                    <Stack justifyContent="space-between" alignItems="center">
                      <h5 style={{ fontSize: 14, margin: '8px 0', fontWeight: 'bold' }}>
                        {floor.name}
                      </h5>
                    </Stack>
                  </Card>
                );
              })}
            </Stack>
          )}
        </Form>
        <Stack justifyContent="space-between" style={{ width: '1150px' }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button onClick={() => setShowCalendar(true)} appearance="subtle">
              <LuCalendarDays />
            </Button>
            <Heading level={5}> {t(format(selectedWeek[0], 'MMMM'))}</Heading>
          </div>
          <div>
            <IconButton
              appearance="subtle"
              circle
              icon={<ArrowLeftLine />}
              onClick={handlePrevWeek}
            />
          </div>
          {selectedWeek.map((date, index) => (
            <p
              key={index}
              style={{
                textAlign: 'center',
                fontSize: 15,
                color: isToday(date) ? '#fff' : '',
                width: '40px',
                height: '40px',
                fontWeight: isToday(date) || isSameDay(date, selectedDate) ? 'bold' : 'normal',
                // lineHeight: '40px',
                borderRadius: '50%',
                backgroundColor: isSameDay(date, selectedDate) ? '#0d47a1' : 'transparent',
                display: 'inline-block',
                padding: 5,
                cursor: 'pointer'
              }}
              onClick={() => {
                // if (!isBefore(date, subDays(new Date(), 1))) {
                setSelectedDate(date);
                // }
              }}
              //   className="semi-bold"
            >
              {t(format(date, 'EEE'))} <br></br> {format(date, 'dd')}
              {/* {format(date, 'MMM')} */}
            </p>
          ))}{' '}
          <div>
            <IconButton
              appearance="subtle"
              circle
              icon={<ArrowRightLine />}
              onClick={handleNextWeek}
            />
          </div>
          {/* <SelectPicker
            data={buildings?.map(building => ({
              ...building,
              value: building?._id,
              label: building?.address
            }))}
            label="Office"
            searchable={false}
            style={{ width: 200, backgroundColor: 'transparent' }}
            placeholder="Select Building"
            value={selectedBuilding}
            onChange={setSelectedBuilding}
            loading={loadingBuildings}
          />
          <SelectPicker
            data={floors?.map(floor => ({
              ...floor,
              value: floor?._id,
              label: floor?.name
            }))}
            searchable={false}
            style={{ width: 200, backgroundColor: 'transparent' }}
            placeholder="Select Floor"
            value={selectedFloor}
            onChange={setSelectedFloor}
            loading={loading}
            label="Floor"
          /> */}
        </Stack>
      </Panel>

      {/* <Stack style={{ paddingBottom: 10, marginTop: 50 }}>
        <div style={{ width: 150 }}></div>
        {hours
          .filter(time => time.endsWith(':00'))
          .map(time => (
            <div key={time} style={{ width: 100 }}>
              {time}
            </div>
          ))}
      </Stack> */}

      {/* <div style={{ display: 'flex', gap: '50px' }}> */}
      <div
        className="meeting-scheduler"
        ref={schedulerRef}
        style={{ width: '100%', overflowX: 'auto' }}
      >
        <div
          className="scheduler"
          style={{
            display: 'grid',
            height: '20px',
            gridTemplateColumns: `150px repeat(${hours.length}, 100px)`,
            // gap: '2px',
            background: 'transparent',
            padding: '5px',
            borderRadius: '8px',
            marginTop: '10px',
            width: '1150px'
          }}
        >
          <div></div>
          {hours.map((hour, index) => (
            // <div key={index}>{hour.endsWith(':00') ? hour : ''}</div>
            <div key={index}>{hour}</div>
          ))}
        </div>
        {rooms?.map((room, index) => (
          <div
            key={index}
            className="scheduler"
            style={{
              position: 'relative',
              display: 'grid',
              height: '100px',
              gridTemplateColumns: `150px repeat(${hours.length}, 100px)`,
              //   gap: '2px',
              background: '#ffffff',
              //   padding: '5px',
              borderRadius: '8px',
              marginTop: '10px'
              // width: '1150px'
            }}
          >
            <div className="room-name">
              {room.name}
              <br />
              <p style={{ fontSize: 12, color: '#777', margin: 0 }}>{room.zone?.floor?.name}</p>
            </div>

            {hours.map((time, index) => {
              const today = isToday(selectedDate);
              const now = new Date();

              const dateToSelect = new Date(selectedDate);
              const [hour, minute] = time.split(':').map(Number);
              dateToSelect.setHours(hour, minute, 0, 0);
              const isPast = today && dateToSelect < now;
              const isReserved = operations.some(
                res =>
                  res.desk._id === room._id &&
                  res.date_debut?.slice(11, 16) <= time &&
                  res.date_fin?.slice(11, 16) > time
              );

              return (
                <div
                  key={index}
                  // className={`${time.includes('30') ? 'half-cell' : 'cell'}`}
                  // onClick={() => {
                  //   handleCellClick(room, time);
                  // }}
                  className={`cell ${isPast || isReserved ? 'disabled' : ''} ${
                    selectedSlots.some(slot => slot.room === room && slot.time === time)
                      ? 'selected'
                      : ''
                  }
                  `}
                  style={{
                    borderTopRightRadius: index == hours?.length - 1 ? '8px' : 0,
                    borderBottomRightRadius: index == hours?.length - 1 ? '8px' : 0
                  }}
                  onMouseDown={
                    !isPast && !isReserved ? () => handleMouseDown(room, time, index) : undefined
                  }
                  // onMouseDown={() => handleMouseDown(room, time, index)}
                  onMouseEnter={() => handleMouseEnter(room, time)}
                  // onMouseUp={handleMouseUp}
                ></div>
              );
            })}

            {operations
              ?.filter(res => res.desk._id === room._id)
              ?.map((op, idx) => {
                const startTime = op.date_debut?.slice(11, 16);
                const endTime = op.date_fin?.slice(11, 16);
                // const startIndex = hours?.indexOf(startTime);
                // const endIndex = hours?.indexOf(endTime);

                // if (startIndex === -1 || endIndex === -1) return null;

                // const cellWidth = schedulerRef.current
                //   ? schedulerRef.current.querySelector('.cell')?.offsetWidth || 50
                //   : 50;
                const cellWidth = 100;
                const [startHour, startMinute] = startTime.split(':').map(Number);
                const [endHour, endMinute] = endTime.split(':').map(Number);
                const startTotalMinutes = startHour * 60 + startMinute;
                const endTotalMinutes = endHour * 60 + endMinute;

                const diffInMinutes = endTotalMinutes - startTotalMinutes;
                const halfHourCount = diffInMinutes / 30;

                const referenceMinutes = 8 * 60;
                const offsetInMinutes = startTotalMinutes - referenceMinutes;
                const halfHourOffset = offsetInMinutes / 30;

                const left = halfHourOffset * cellWidth + 150;
                const width = halfHourCount * cellWidth;

                console.log('start', op.date_debut, 'end ', op.date_fin);
                console.log('startTime', startTime, 'endTime ', endTime);
                console.log('width', width);
                console.log('left', left);

                return (
                  <div
                    key={idx}
                    className="reservation-card"
                    // style={{
                    //   position: 'absolute',
                    //   // top: '50%',
                    //   // transform: 'translateY(-50%)',
                    //   top: 0,
                    //   transform: 'none',
                    //   left: `${
                    //     startIndex == 0
                    //       ? 150 + startIndex * cellWidth
                    //       : 166 + startIndex * cellWidth
                    //   }px`,

                    //   // left: `${160 + startIndex * cellWidth}px`,
                    //   width: `${(endIndex - startIndex) * cellWidth}px`,
                    //   height: '80%',
                    //   background: 'rgba(121, 168, 218, 0.7)',
                    //   color: '#4b4b4b',
                    //   padding: '10px',
                    //   borderRadius: '8px',
                    //   // marginLeft: '10px',
                    //   // marginRight: '10px',
                    //   // textAlign: 'center',
                    //   // display: 'flex',
                    //   // flexWrap: "wrap",
                    //   // alignItems: 'center',
                    //   // justifyContent: 'center',
                    //   zIndex: 10
                    // }}
                    style={{
                      position: 'absolute',
                      left,
                      width,
                      height: '90%',
                      overflowY: 'auto',
                      //   background: '#acbfde',
                      background: 'rgb(216 227 238)',
                      //   background: 'rgba(121, 168, 218, 0.7)',
                      borderRadius: 6,
                      padding: '4px 6px',
                      fontSize: 12,
                      color: '#4b4b4b'
                    }}
                  >
                    <Stack justifyContent="space-between">
                      <Stack spacing={5} wrap>
                        {op.user.photo ? (
                          <Avatar
                            circle
                            src={process.env.REACT_APP_IMAGE_URL + op.user.photo}
                            alt={op.user.firstname}
                            size="xs"
                          />
                        ) : (
                          <Avatar circle size="xs" />
                        )}

                        <p
                          style={{ fontSize: 12, margin: 0, fontWeight: 'bold', color: '#3f5f89' }}
                        >
                          {op.user?.firstname} {op.user?.lastname || op.guest}
                        </p>
                      </Stack>
                      {canDelete(op.date_debut) && (
                        <IconButton
                          appearance="subtle"
                          circle
                          size="xs"
                          icon={<Trash color="red" />}
                          onClick={e => {
                            e.stopPropagation();
                            setConfirmDialog({
                              open: true,
                              title: t('Are you sure to delete this reservation ?'),
                              subtitle: '',
                              onConfirm: () => {
                                handleDelete(op._id);
                              }
                            });
                          }}
                        />
                      )}
                    </Stack>
                    {/* <img
                      src="URL_DE_L_IMAGE"
                      alt={res.user.firstname}
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        marginRight: '5px'
                      }}
                    /> */}
                    <Stack spacing={5}>
                      <IoMdTime style={{ color: '#3f5f89' }} />{' '}
                      <p style={{ fontSize: 12, margin: 0, color: '#3f5f89' }}>
                        {startTime} - {endTime}
                      </p>
                    </Stack>
                    <Stack spacing={5}>
                      <GrWorkshop style={{ color: '#3f5f89' }} />
                      <p style={{ fontSize: 12, margin: 0, fontWeight: 'bold', color: '#3f5f89' }}>
                        {op.subject}
                      </p>
                    </Stack>

                    <Stack spacing={5}>
                      <LuUsers style={{ color: '#3f5f89' }} />
                      <MembersDisplay members={op.members} />
                    </Stack>
                  </div>
                );
              })}

            {/* {operations
              .filter(res => res.desk._id === room._id)
              .map((res, idx) => {
                const startTime = res.date_debut.slice(11, 16);
                const endTime = res.date_fin.slice(11, 16);
                const startIndex = hours.indexOf(startTime);
                const endIndex = hours.indexOf(endTime);

                if (startIndex === -1 || endIndex === -1) return null;

                return (
                  <div
                    key={idx}
                    className="reservation-card"
                    style={{
                      gridColumn: `${startIndex + 2} / ${endIndex + 2}`, // S'assurer que l'index est bon
                      height: '100%', // Remplit la cellule
                      width: '100%', // S'ajuste à la cellule
                      background: 'rgba(255, 0, 0, 0.9)', // Meilleure couleur
                      color: '#fff',
                      padding: '10px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {res.user.firstname} {res.user.lastname}
                  </div>
                );
              })} */}
          </div>
        ))}
      </div>
      {/* </div> */}

      {/* <div
        style={{ overflowX: 'auto', width: '100%' }}
        className="meeting-scheduler"
        ref={schedulerRef}
      >
        <div
          className="scheduler"
          style={{
            display: 'grid',
            gridTemplateColumns: `150px repeat(${hours.length}, 50px)`,
            background: 'transparent'
          }}
        >
          <div></div>
          {hours.map((hour, index) => (
            <div
              key={index}
              style={{
                padding: '5px',
                fontSize: 12,
                textAlign: 'center',
                borderLeft: '1px solid #eee'
              }}
            >
              {hour}
            </div>
          ))}
        </div>

        {rooms?.map((resource, resourceIndex) => (
          <div
            key={resourceIndex}
            style={{
              display: 'grid',
              gridTemplateColumns: `150px repeat(${hours.length}, 50px)`,
              alignItems: 'center',
              background: '#ffffff',
              height: '100px',
              position: 'relative',
              borderTop: '1px solid #eee',
              marginTop: '10px'
            }}
          >
            <div className="room-name" style={{ padding: '5px', fontWeight: 'bold' }}>
              {resource.name}
            </div>

            {hours?.map((time, cellIndex) => {
              const today = isToday(selectedDate);
              const now = new Date();

              const dateToSelect = new Date(selectedDate);
              const isPast = today && dateToSelect < now;
              const isReserved = operations.some(
                res =>
                  res.desk._id === resource._id &&
                  res.date_debut?.slice(11, 16) <= time &&
                  res.date_fin?.slice(11, 16) > time
              );
              return (
                <div
                  key={cellIndex}
                  className={`cell ${isPast || isReserved ? 'disabled' : ''} ${
                    selectedSlots.some(slot => slot.room === resource && slot.time === time)
                      ? 'selected'
                      : ''
                  }
              `}
                />
              );
            })}

            {mockOperations
              ?.filter(op => op.desk._id === resource._id)
              ?.map((op, idx) => {
                const start = new Date(op.date_debut);
                const end = new Date(op.date_fin);
                const startIndex = (start.getHours() - 8) * 2 + (start.getMinutes() >= 30 ? 1 : 0);
                const endIndex = (end.getHours() - 8) * 2 + (end.getMinutes() > 0 ? 1 : 0);
                const span = endIndex - startIndex;
                const cellWidth = 50;
                const startTime = op.date_debut?.slice(11, 16);
                const endTime = op.date_fin?.slice(11, 16);
                const [startHour, startMinute] = startTime.split(':').map(Number);
                const [endHour, endMinute] = endTime.split(':').map(Number);
                const startTotalMinutes = startHour * 60 + startMinute;
                const endTotalMinutes = endHour * 60 + endMinute;

                const diffInMinutes = endTotalMinutes - startTotalMinutes;
                const halfHourCount = diffInMinutes / 30;
                console.log('halfHourCount', halfHourCount);

                const referenceMinutes = 8 * 60;
                const offsetInMinutes = startTotalMinutes - referenceMinutes;
                const halfHourOffset = offsetInMinutes / 30;
                console.log('halfHourOffset', halfHourOffset);

                const left = halfHourOffset * cellWidth + 150;
                const width = halfHourCount * cellWidth;

                return (
                  <div
                    key={idx}
                    style={{
                      position: 'absolute',
                      //   left: `calc(150px + ${startIndex} * 50px)`,
                      left,
                      width,
                      //   gridColumn: `${startIndex + 2} / span ${span}`,
                      height: '60%',
                      background: '#9bc3e6',
                      borderRadius: 6,
                      padding: '5px',
                      color: '#333',
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 12,
                      zIndex: 1
                    }}
                  >
                    {op.user.firstname} {op.user.lastname}
                  </div>
                );
              })}
          </div>
        ))}
      </div> */}

      {showModal.open && (
        <Modal
          open={showModal.open}
          onClose={() => {
            setShowModal({ open: false });
            setFormValue({});
          }}
          size="xs"
        >
          <Modal.Header>
            <Modal.Title>
              <strong>
                {t('Book')} {showModal?.room?.name}
              </strong>
              <p style={{ fontSize: 12, color: '#777', paddingTop: 5 }}>
                {showModal.room.zone?.floor?.name} | Capacity: {showModal.room.capacity}
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ marginTop: 50 }}>
              <Form fluid formValue={formValue} onChange={value => setFormValue(value)}>
                <Stack justifyContent="space-between" wrap>
                  <Form.Group>
                    <Form.ControlLabel>{t('Date')}</Form.ControlLabel>
                    <DatePicker readOnly value={selectedDate} style={{ width: 180 }} />
                  </Form.Group>
                  <Form.Group>
                    <Form.ControlLabel>{t('Time')}</Form.ControlLabel>
                    <InputGroup style={{ width: 160 }}>
                      <Input value={formValue?.startTime} readOnly />
                      <InputGroup.Addon>{t('to')}</InputGroup.Addon>
                      <Input value={formValue?.endTime} readOnly />
                    </InputGroup>
                  </Form.Group>
                </Stack>
                <Form.Group style={{ marginTop: 10 }}>
                  <Form.ControlLabel>{t('Subject')}</Form.ControlLabel>
                  <Form.Control name="subject" accepter={Input} placeholder="Subject" block />
                </Form.Group>
                <Form.Group style={{ marginTop: 10 }}>
                  <Form.ControlLabel>{t('Members')}</Form.ControlLabel>
                  <Form.Control
                    name="team"
                    accepter={TagPicker}
                    data={users.map(user => ({
                      ...user,
                      label: user.firstname + ' ' + user.lastname,
                      value: user._id
                    }))}
                    searchable
                    placeholder={t('Select members')}
                    block
                    multiple
                    placement="auto"
                  />
                </Form.Group>
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleConfirm} appearance="primary">
              {t('Confirm')}
            </Button>
            <Button
              onClick={() => {
                setShowModal({ open: false });
                setFormValue({});
              }}
              appearance="subtle"
            >
              {t('Cancel')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <Modal open={showCalendar} onClose={() => setShowCalendar(false)}>
        <Modal.Header>
          <Modal.Title>{t('Choose a Week')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Calendar
            // bordered
            onSelect={handleDateSelect}
            compact
            weekStart={1}
            showWeekNumbers={true}
          />
        </Modal.Body>
      </Modal>

      {confirmDialog?.open == true && (
        <ConfirmModal confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      )}
    </div>
  );
};

export default MeetingSchedule;

const generateWeek = date => {
  const start = new Date(date);

  const dayOfWeek = start.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  start.setDate(date.getDate() - daysToSubtract);

  return Array.from({ length: 7 }, (_, i) => {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    return day;
  });
};
